import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { useOne } from "@hmn/coolinarika-web-core/hooks";

import { ConditionalWrapper } from "../../../ConditionalWrapper";
import { Image, imageRoundedVariants } from "../../../Image";
import { Link } from "../../../Link";
import styles from "./GalleryImage.style";

const DrawerGalleryImageStyled = styled.div((props) => ({ ...styles(props) }));

const DrawerGalleryImage = ({
    className,
    image: initialImage,
    imageWidth,
    imageHeight,
    href,
    hrefAs,
    ...rest
}) => {
    // We still need to fetch single image, to get original aspect data
    const { data: image } = useOne("images", { id: initialImage?.id || initialImage?.image }, {});

    if (!initialImage) {
        return null;
    }

    return (
        <DrawerGalleryImageStyled className={className} {...rest}>
            <ConditionalWrapper condition={!!href} Wrapper={Link} href={href} as={hrefAs}>
                <Image
                    image={image}
                    ratio="original-aspect"
                    width={imageWidth}
                    rounded={imageRoundedVariants.SMALL}
                />
            </ConditionalWrapper>
        </DrawerGalleryImageStyled>
    );
};

DrawerGalleryImage.propTypes = {
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    imageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    href: PropTypes.string,
    hrefAs: PropTypes.string,
};

DrawerGalleryImage.defaultProps = {
    image: undefined,
    imageWidth: 1280,
    imageHeight: undefined,
    className: undefined,
    href: undefined,
    hrefAs: undefined,
};

export default DrawerGalleryImage;
